import { render } from "./Saldos.vue?vue&type=template&id=1fb55e01&scoped=true"
import script from "./Saldos.vue?vue&type=script&lang=js"
export * from "./Saldos.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "../filtros.css?vue&type=style&index=1&id=1fb55e01&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb55e01"]])

export default __exports__